import React from 'react';
import { Plus, X, AlertCircle } from 'lucide-react';

const MediaUploader = ({ media, setMedia }) => {
    const processFiles = async (files) => {
        const hasVideo = media.some(m => m.type === 'video');
        const hasImage = media.some(m => m.type === 'image');
        const remainingQuota = 9 - media.length;

        for (const file of files.slice(0, remainingQuota)) {
            const isVideo = file.type.startsWith('video/');

            if (hasVideo || (hasImage && isVideo)) {
                alert("Cannot mix images and videos.");
                break;
            }

            let duration = 0;
            if (isVideo) {
                duration = await new Promise((resolve) => {
                    const video = document.createElement('video');
                    video.preload = 'metadata';
                    video.src = URL.createObjectURL(file);
                    video.onloadedmetadata = () => {
                        URL.revokeObjectURL(video.src);
                        resolve(video.duration);
                    };
                });
            }

            const newItem = {
                id: Math.random().toString(36).substring(2, 9),
                file,
                preview: URL.createObjectURL(file),
                type: isVideo ? 'video' : 'image',
                duration,
            };

            setMedia(prev => isVideo ? [newItem] : [...prev, newItem]);
            if (isVideo) break;
        }
    };

    const handleFileChange = async (e) => {
        const files = Array.from(e.target.files);
        await processFiles(files);
        e.target.value = null;
    };

    const removeMedia = (indexToRemove) => {
        setMedia(prev => {
            const item = prev[indexToRemove];
            if (item?.preview) URL.revokeObjectURL(item.preview);
            return prev.filter((_, index) => index !== indexToRemove);
        });
    };

    return (
        <div className="mt-6">
            <div className="flex justify-between items-end mb-2">
                {media.some(m => m.incompatiblePlatforms?.length > 0) && (
                    <span className="text-[10px] text-orange-600 flex items-center gap-1 bg-orange-50 px-2 py-0.5 rounded">
                        <AlertCircle size={10} /> Limits detected
                    </span>
                )}
            </div>

            <div className="grid grid-cols-3 gap-4">
                {media.map((item, index) => (
                    <div key={item.id} className="relative aspect-square rounded-xl overflow-hidden border bg-gray-50 group">
                        {item.type === 'video' ? (
                            <video src={item.preview} className="w-full h-full object-cover" />
                        ) : (
                            <img src={item.preview} className="w-full h-full object-cover" />
                        )}
                        <button onClick={() => removeMedia(index)} className="absolute top-1 right-1 p-1 bg-black/50 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
                            <X size={14} />
                        </button>
                    </div>
                ))}
                {media.length < 9 && (
                    <label className="flex flex-col items-center justify-center aspect-square border-2 border-dashed border-gray-300 rounded-xl cursor-pointer hover:bg-gray-50 transition-colors">
                        <Plus className="text-gray-400" />
                        <input type="file" multiple accept="image/*,video/*" className="hidden" onChange={handleFileChange} />
                    </label>
                )}
            </div>
        </div>
    );
};

export default MediaUploader;